import { signal } from "@preact/signals-react"
import { useEffect } from "react"

export const deviceSchema = signal({})
export const loading = signal(false)
export const isLoaded = signal(false)
export const error = signal(null)

const fetchData = async (deviceName, manifest, config, accessToken) => {

    // short-circuit if we are waiting for more parameters or already loading
    if (loading.value || !deviceName || !manifest || !config || !accessToken) {
        return
    }
    
    try {
        loading.value = true

        const manifestDeviceEntry = manifest["device-profiles"].find(p => p.name == deviceName && p.version == 2)
        if (!manifestDeviceEntry) {
            throw new Error(`Unable to locate the device schema manifest entry for ${deviceName}.`)
        }

        // TODO: the manifest file assumes all schemas are in the /react/* folder. 
        // we'll have to adjust the manifest file but for now remove this path

        const filePath = manifestDeviceEntry.file.startsWith('/react') ? manifestDeviceEntry.file.slice(6) :  manifestDeviceEntry.file
        const response = await fetch(filePath)   
        let data = await response.json()
        deviceSchema.value = data
        isLoaded.value = true
        return data
    }
    catch(err) {
        error.value = err
        console.log(err)
    }
    finally {
        loading.value = false
    }  
    
}

export default function useProfileDeviceSchema(deviceName, manifest, config, accessToken) {
    useEffect(() => {
        fetchData(deviceName, manifest, config, accessToken)
    }, [deviceName, manifest, config, accessToken])

    return {
        deviceSchema, loading, error, fetchData
    }
}